module.exports = __webpack_public_path__ + "static/media/3.8c15f487.webp";